/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectPurchasedNFTs = (state) =>
  state['feature/purchase-nfts'] || initialState;
//
export const purchaseNFTLoader = createSelector(
  [selectPurchasedNFTs],
  (state) => state.isLoading
);
export const purchaseNFTError = createSelector(
  [selectPurchasedNFTs],
  (state) => state.errorMessage
);
export const purchaseNFTSuccess = createSelector(
  [selectPurchasedNFTs],
  (state) => state.isSuccess
);
